<template>
  <div
    class="logo-bottom"
    ref="btmComp"
  >
    <g-img
      class="img c-p-b-20"
      :src="require('i/copyright_icon.png')"
      size="224"
      normal
      alt=""
    />
  </div>
</template>

<script>
export default {
  name: "GBottom",
  props: {
    block: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {

    };
  },
  created() {
    this.init();
  },
  mounted() {

  },

  watch: {

  },
  methods: {
    init() {
      if (this.block) {
        this.$nextTick(() => {
          let btmComp = this.$refs.btmComp;
          btmComp.style.position = 'static'
        })
      }
    }
  }
};
</script>
<style scoped lang='scss'>
.logo-bottom {
  width: 100%;
  background-color: rgba(255, 0, 0, 0);
  text-align: center;
  margin-top:20px;
  position: absolute;
  bottom: 0;
}
.img {
  width: 224px;
  height: 82px;
  margin: 0 auto;
}
</style>
